import { useIsModuleEnabled } from "src/hooks/useIsModuleEnabled";

export const useIsCaseManagementEnabled = (): {
  isEnabled: boolean;
} => {
  return useIsModuleEnabled("case_management");
};
